import { gql } from '@apollo/client';
import client from 'apollo/apollo-client';

export async function userRemove({ userId }) {
  return await new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: REMOVE_USERS,
        variables: { userId },
        skip: skip({ userId }),
        refetchQueries: ['UsersByCustomer'],
      })
      .then(
        ({
          data: {
            UserRemove: { error, data, message },
          },
          loading,
        }) => {
          resolve({ data, loading, error, message });
        },
      )
      .catch((error) => {
        reject(new Error({ error: true, message: error.message, data: {} }));
      });
  });
}

function skip({ userId }) {
  let skip = true;
  console.log(userId);
  skip = ![userId].every((v) => v);
  return skip;
}

const REMOVE_USERS = gql`
  mutation UserRemove($userId: ID!) {
    UserRemove(userId: $userId) {
      error
      data {
        _id
        name
        email
        roles
        language
        active
      }
      message
    }
  }
`;
